module.exports = __webpack_public_path__ + "static/media/keyvisual-lg-rgb.34e510e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keyvisual-lg-rgb.jpg
// module id = 446
// module chunks = 0